import Modal from "antd/es/modal/Modal";
import React, { useContext, useEffect } from "react";
import ConfirmApiContext from "../../contexts/confirmApi";

const ConfirmModal = () => {
  const [confirmApiState, confirmApiDispatcher] = useContext(ConfirmApiContext);

  useEffect(() => {
    if (confirmApiState.async && !confirmApiState.loading) {
      confirmApiDispatcher({
        type: "hide",
      });
    }
  }, [confirmApiState.loading]);

  const handleCancel = function () {
    confirmApiDispatcher({
      type: "hide",
    });
  };

  const handleOk = function () {
    confirmApiState.onOk();

    if (!confirmApiState.async) {
      console.log("async?", confirmApiState.async);
      confirmApiDispatcher({
        type: "hide",
      });
    }
  };

  return (
    <div>
      <Modal
        title={confirmApiState.title}
        visible={confirmApiState.isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmApiState.loading}
      >
        <p>{confirmApiState.message}</p>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
